// src/components/common/ConsoleOverviewLayout.tsx

import { Box } from "@mui/material";
import OverviewFooter, { OverviewFooterProps } from "../../../common/OverviewFooter/OverviewFooter";
import { IntegrationOption, OverviewIntegrations } from "../Integrations/OverviewIntegrations";
import styles from "./ConsoleOverviewLayout.module.scss";
import clsx from "clsx";

interface Props {
	className?: string;
	copyApiTokenProps: OverviewFooterProps;
	integrations?: IntegrationOption[];
	pageName?: string;
	children: React.ReactNode;
}

const ConsoleOverviewLayout = ({ copyApiTokenProps, integrations, children, className, pageName }: Props) => {
	return (
		<Box className={clsx(styles.layout, className)}>
			<Box className={styles.overview}>
				<OverviewFooter className={styles.footer} {...copyApiTokenProps} />
				{children}
			</Box>
			{integrations && <OverviewIntegrations className={styles.integrations} cards={integrations} pageName={pageName}/>}
		</Box>
	);
};

export default ConsoleOverviewLayout;
